import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import CommonCardHeader from '../../../../coreComponents/CommonCardHeader';
import { useTranslation } from 'react-i18next';
import { sendTestQueueJob } from '../../../../services/api';

const ExamTranscriptions = (props: {
  callTranscriptionId?: string;
  callAudioId?: string;
  handleEdit: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={t('courses.exam.examTranscription')} />
        <CardBody>
          {props.callTranscriptionId && (
            <Col sm="6">
              <Row>
                <Col sm="12">
                  <Card className="position-relative">
                    <CommonCardHeader title={t('bot.botFilesTableTitle')} tag />

                    <CardBody>
                      <Row className="d-flex flex-row justify-space-between align-items-center">
                        <Col sm="8">
                          <a
                            href={`${process.env.REACT_APP_BACKEND_STATIC}/transcripts/${props.callTranscriptionId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-inline-flex w-auto"
                          >
                            {props.callTranscriptionId}
                          </a>
                        </Col>

                        <Col sm="4" className="d-flex justify-content-end">
                          <Button onClick={props.handleEdit} color="warning">
                            {' '}
                            <i className="icon-pencil-alt" /> {t('bot.transcriptionEditRow')}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          )}
          {props.callAudioId && (
            <Col sm="6">
              {/* <CommonCardHeader title={t('courses.coursesList.coursesListCardTitle')} tag /> */}
              <Row>
                <Col sm="12">
                  <Card className="position-relative">
                    <CommonCardHeader title={t('bot.botAudioFilesTitle')} tag />

                    <CardBody>
                      <Row>
                        <a href={`${process.env.REACT_APP_BACKEND_STATIC}/${props.callAudioId}`}>
                          {props.callAudioId}
                        </a>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          )}{' '}
          
        </CardBody>{' '}
      </Card>
    </Col>
  );
};
export default ExamTranscriptions;
